const HEIC_EXTENSION = /\.hei[cf]$/i;
const HEIC_MIME_TYPES = ['image/heic', 'image/heif'];

export const isHeicFile = (file: File): boolean =>
  HEIC_MIME_TYPES.includes(file.type) || HEIC_EXTENSION.test(file.name);

export const convertHeicToJpeg = async (file: File): Promise<File> => {
  const { heicTo } = await import('heic-to');
  const jpeg = await heicTo({ blob: file, type: 'image/jpeg', quality: 0.9 });
  return new File([jpeg], file.name.replace(HEIC_EXTENSION, '.jpg'), {
    type: 'image/jpeg',
  });
};
